import { render, staticRenderFns } from "./apply-to-partnership-widget.vue?vue&type=template&id=27c41b1b&"
import script from "./apply-to-partnership-widget.vue?vue&type=script&lang=js&"
export * from "./apply-to-partnership-widget.vue?vue&type=script&lang=js&"
import style0 from "./apply-to-partnership-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports